export default __webpack_public_path__ + "static/media/ArrowUp.ecc1bb37.svg";